import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {DataService} from '../data-service';

@Injectable()
export class SettingsDataService extends DataService {

  getSettings(): Promise<any> {
    return this.get('', {'parking-lots': 'PARKING_LOT_ID'}, '');
  }

  setSettings(data): Promise<any> {
    const options = {headers: new HttpHeaders().set('Content-Type', 'application/json')};
    return this.put('', {'parking-lots': 'PARKING_LOT_ID'}, '',
      JSON.stringify(data), options);
  }

  savePercentageReduction(data): Promise<any> {

    const params = {
      usagePercentage: data.usageReducePercentage, // Send the usage reduction percentage
      dailyPercentage: data.dayReducePercentage   // Send the daily reduction percentage
    };

    const prefix = '';
    const suffix = '/parking-spaces-percentage';

    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      params: params
    };

    return this.put(prefix, {'parking-lots': 'PARKING_LOT_ID'}, suffix, '', options);
  }


}



// WEBPACK FOOTER //
// ./src/app/core/data-services/settings/settings.service.ts